import { useEffect } from 'react';

import { useEmbed } from './embed-context';

/**
 * Reports the document height to the embedding host page so it can resize the
 * iframe and avoid an inner scrollbar.
 *
 * The host listens for `{ type: 'mdenture:height', height }` — see the README
 * for the snippet the PHP page needs.
 */
export function useIframeHeightReporter(): void {
  const { embedded, postToHost } = useEmbed();

  useEffect(() => {
    if (!embedded || typeof ResizeObserver === 'undefined') {
      return;
    }

    const target = document.documentElement;
    let lastHeight = 0;

    function report(): void {
      const height = Math.ceil(target.getBoundingClientRect().height);
      if (height !== lastHeight) {
        lastHeight = height;
        postToHost({ type: 'mdenture:height', height });
      }
    }

    const observer = new ResizeObserver(report);
    observer.observe(target);
    report();

    return () => observer.disconnect();
  }, [embedded, postToHost]);
}
